module.exports = ".element-padding{padding:10px}.dropdown-item.active{background-color:#f9f9f9;color:#0071bc}.input-label{padding:0 0 15px 0;color:#121212}.reset-padding{padding-top:10px;padding-bottom:10px;padding-left:0;padding-right:0}.modal .btn-submit{right:0}.btn:hover{cursor:pointer}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/app-restrictions/restrict-user/restrict-user.component.scss
// module id = 898
// module chunks = 9